import { render, staticRenderFns } from "./maintenancePendingTreatment.vue?vue&type=template&id=601caee2&scoped=true&"
import script from "./maintenancePendingTreatment.vue?vue&type=script&lang=js&"
export * from "./maintenancePendingTreatment.vue?vue&type=script&lang=js&"
import style0 from "./maintenancePendingTreatment.vue?vue&type=style&index=0&id=601caee2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "601caee2",
  null
  
)

export default component.exports